export const settings = {
    language: {
        options: {
            system: 'Sistema',
            // Nome de idioma aparece SEMPRE no próprio idioma (convenção de i18n):
            // quem caiu num idioma que não lê precisa reconhecer o seu na lista.
            'pt-BR': 'Português (BR)',
            en: 'English',
        },
    },
    // Títulos de header do Stack (app/settings/_layout.tsx) — inclui telas de
    // outras áreas porque o layout é um arquivo só.
    screens: {
        index: 'Configurações',
        preferences: 'Preferências',
        appearance: 'Aparência',
        appIcon: 'Ícone do app',
        homeLayout: 'Personalizar início',
        analysisLayout: 'Personalizar análise',
        tabSlot: 'Atalho da barra',
        homeShortcuts: 'Atalhos da tela inicial',
        reminders: 'Lembretes',
        iosQuickCapture: 'Captura rápida',
        ai: 'Assistente IA',
        maintenance: 'Manutenção',
        backup: 'Backup e Sync',
        backups: 'Pontos de restauração',
        backupMore: 'Mais opções',
        import: 'Importar e exportar',
        security: 'Segurança',
        autoCategorization: 'Categorização Automática',
        feedback: 'Enviar feedback',
    },
    index: {
        sections: {
            personalization: 'Personalização',
            notifications: 'Notificações',
            automation: 'Automação',
            dataSecurity: 'Dados e segurança',
        },
        rows: {
            appearance: 'Aparência',
            homeLayout: 'Personalizar início',
            analysisLayout: 'Personalizar análise',
            tabSlot: 'Atalho da barra',
            preferences: 'Preferências',
            reminders: 'Lembretes',
            remindersDisabled: 'Desativadas',
            bankNotifications: 'Notificações bancárias',
            bankNotificationsValue: 'Android',
            // Acesso a notificações nunca liberado (ou revogado pelo Android)
            bankNotificationsOff: 'Acesso desligado',
            // Captura muda (permissão ok, nada chega há 24h+) — ver hooks/useListenerHealth
            bankNotificationsSilent: 'Leitura parada',
            iosQuickCapture: 'Captura rápida',
            iosQuickCaptureValue: 'iPhone',
            autoCategorization: 'Categorização automática',
            aiAssistant: 'Assistente IA',
            aiPending: 'Pendente',
            security: 'Segurança',
            securityEnabled: 'Ativo',
            securityDisabled: 'Desativado',
            backup: 'Backup',
            backupValue: 'Nuvem e arquivos',
            dataTransfer: 'Importar e exportar',
            maintenance: 'Manutenção',
            managePlan: 'Gerenciar plano',
            managePlanValue: 'Pro',
            meetPro: 'Conhecer o Kontto Pro',
            rateApp: 'Avaliar o Kontto',
            sendFeedback: 'Enviar feedback',
        },
    },
    iosQuickCapture: {
        hero: {
            eyebrow: 'ATALHOS DO IPHONE',
            title: 'Capture sem abrir o Kontto',
            subtitle: 'Com Apple Pay ou dois toques. Você revisa tudo em Pendências.',
            // iOS 27+: a notificação do banco é o caminho principal (ADR 0152).
            subtitleBank: 'Pela notificação do seu banco, com Apple Pay ou dois toques. Você revisa tudo em Pendências.',
        },
        privacy: 'Suas capturas ficam no seu iPhone.',
        triggersLabel: 'Formas de capturar',
        manualSetupTitle: 'Escolha o gesto nos Ajustes do iPhone',
        manualSetupNote: 'O atalho acima já vem pronto — não tem nada para montar. Falta só ligar o gesto:',
        bankSetup: {
            note: 'Quando o seu banco avisar de um Pix ou compra, o Kontto guarda como pendência. Funciona com mais de 40 bancos e com a Carteira do iPhone.',
            steps: [
                'Toque em Adicionar ao Atalhos e confirme no iPhone.',
                'No app Atalhos, vá em Biblioteca › Automação e ligue “Quando eu receber uma notificação de um dos… apps”. Ela chega desligada.',
                'Pronto. A próxima notificação do seu banco vai para Pendências.',
            ],
            done: 'Já liguei a automação',
        },
        walletGuide: {
            once: 'Configure uma vez no Atalhos',
            inShortcuts: 'NO APP ATALHOS',
            example: 'EXEMPLO NO KONTTO',
            progress: 'Etapa {{current}} de {{total}}',
            next: 'Próxima etapa',
            back: 'Voltar',
            finish: 'Já salvei no Atalhos',
            returnHint: 'Alterne entre Atalhos e Kontto para acompanhar. O guia continua nesta etapa.',
            // Réplicas do app Atalhos (iOS 18.6, pt-BR) — mesmos rótulos que o usuário vai ver lá.
            automationTab: 'Automação',
            noAutomations: 'Nenhuma Automação',
            newAutomation: 'Nova Automação',
            personalAutomation: 'Automação Pessoal',
            transactionTrigger: 'Transação',
            transactionExample: 'Ex.: “Quando eu aproximar um Cartão ou Tíquete do app Carteira”',
            walletTrigger: 'Carteira',
            navBack: 'Voltar',
            navNext: 'Seguinte',
            navDone: 'OK',
            whenITap: 'Quando eu aproximar',
            cardsHeader: 'Cartão',
            creditCard: 'Cartão de crédito',
            debitCard: 'Cartão de débito',
            runAfterConfirmation: 'Executar Após Confirmação',
            runImmediately: 'Executar Imediatamente',
            notifyWhenRun: 'Notificar Quando Executar',
            blankAutomation: 'Nova Automação em Branco',
            blankShortcut: 'Novo Atalho em Branco',
            searchActions: 'Buscar Ações',
            captureAction: 'Capturar compra da Carteira',
            captureActionInline: 'Capturar compra de',
            alwaysAsk: 'Sempre Perguntar',
            shortcutInput: 'Entrada do Atalho',
            // Campo da ação do Kontto (KonttoWalletPurchaseIntent). Em pt-BR coincide com a
            // propriedade Valor da compra, que é da Apple e muda com o idioma do iPhone.
            amountField: 'Valor',
            amountProperty: 'Valor',
            ifAsked: 'Escolha Valor na lista. Com a Entrada do Atalho inteira, a compra não chega ao Kontto.',
            merchantField: 'Estabelecimento',
            cardField: 'Cartão ou passe',
            screens: {
                create: 'Réplica do Atalhos: aba Automação, botão Nova Automação e a opção {{trigger}}.',
                options: 'Réplica do Atalhos: cartões marcados, Executar Imediatamente selecionado e Notificar Quando Executar desligado.',
                action: 'Réplica do Atalhos: {{blankTile}}, busca por Kontto e a ação Capturar compra da Carteira.',
                connect: 'Réplica do Atalhos: campo de valor da ação, barra de variáveis com Entrada do Atalho, a propriedade Valor escolhida e a ação preenchida.',
                save: 'Réplica do Atalhos: botão OK no canto superior direito.',
            },
            examplePurchase: 'Compra com Apple Pay',
            reviewFirst: 'Só entra no saldo depois da sua confirmação.',
            steps: [
                {
                    title: 'Crie a automação',
                    body: 'No app Atalhos, abra a aba Automação, toque em Nova Automação e escolha {{trigger}}.',
                    hint: 'Já tem automações? O botão vira um + no canto superior direito.',
                },
                {
                    title: 'Escolha seus cartões',
                    body: 'Marque os cartões que usa no Apple Pay e escolha Executar Imediatamente. Deixe Notificar Quando Executar desligado.',
                    hint: 'Toque em Seguinte para continuar.',
                },
                {
                    title: 'Adicione a ação do Kontto',
                    body: 'Toque em {{blankTile}}. Em Buscar Ações, digite Kontto e escolha a ação abaixo.',
                    hint: 'Para Apple Pay, não precisa instalar outro atalho.',
                },
                {
                    title: 'Conecte o valor da compra',
                    body: 'Toque em Valor na ação. Na barra acima do teclado, toque em Entrada do Atalho. Depois toque em Entrada do Atalho, dentro da ação, e escolha Valor.',
                    hint: 'Já tem a automação? Confira se o campo mostra Valor, e não Entrada do Atalho. Estabelecimento e Cartão ou passe são opcionais.',
                },
                {
                    title: 'Salve e pronto',
                    body: 'Toque em OK no canto superior direito. A próxima compra por aproximação vai para Pendências.',
                    hint: 'O status muda para Ativo quando chegar a primeira compra real.',
                },
            ],
        },
        howItWorks: {
            exampleOnly: 'Demonstração interativa · não salva dados',
            transactionSaved: 'Transação salva',
            removedFromPending: 'O gasto sai das Pendências e aparece nos seus lançamentos.',
            tapToReview: 'Toque no gasto para revisar',
            quickCapture: 'Captura rápida',
            exampleAccount: 'Conta de exemplo',
            exampleCard: 'Cartão de exemplo',
            exampleCategory: 'Alimentação',
            sceneLabels: ['Na fila', 'Revisar', 'Resultado'],
            restart: 'Experimentar de novo',
            discardedTitle: 'Captura descartada',
            discardedExample: 'A captura sai da fila sem criar um lançamento.',
            open: 'Ver como funciona',
            title: 'Como funciona',
            close: 'Fechar',
            saved: 'Captura salva',
            now: 'agora',
            pendingHeader: 'Pendências · 1',
            confirm: 'Confirmar',
            discard: 'Descartar',
            ask: 'Qual foi o valor?',
            chips: ['Alimentação', 'Transporte', 'Outro'],
            cases: {
                ios_wallet: {
                    label: 'Apple Pay',
                    amount: 'R$ 48,90',
                    merchant: 'Padaria Estrela',
                    category: 'Alimentação · Nubank · hoje 14:02',
                    captions: [
                        'Depois de configurar, pague por aproximação. A compra chega assim às Pendências.',
                        'Ao tocar na compra, confira cartão, categoria e valor. Depois, confirme.',
                        'Pronto: a compra saiu da fila e virou um lançamento.',
                    ],
                },
                ios_quick_manual: {
                    label: 'Dois toques',
                    amount: 'R$ 35,00',
                    merchant: 'Gasto rápido',
                    category: 'Alimentação · hoje 12:15',
                    captions: [
                        'Dê dois toques atrás do iPhone e informe valor e categoria. O gasto chega aqui.',
                        'Toque no gasto e confira a conta e a categoria antes de confirmar.',
                        'Pronto: o gasto saiu da fila e entrou nos seus lançamentos.',
                    ],
                },
            },
        },
        shortcut: {
            title: 'Atalho dos dois toques',
            ready: 'Instale uma vez para abrir o formulário com o gesto.',
            verifying: 'Conferindo instalação…',
            installed: 'Instalado · versão {{version}}',
            notFound: 'Não encontramos o atalho no seu iPhone',
            outdated: 'Nova versão disponível',
            updateHint: 'No Atalhos, escolha Substituir. “Manter Ambos” cria uma cópia e não atualiza este atalho.',
        },
        trigger: {
            configure: 'Configurar',
            waiting: 'Aguardando',
            active: 'Ativo',
            ios_wallet: {
                title: 'Apple Pay',
                subtitle: 'Automático por aproximação',
                // iOS 27+: a notificação do banco já cobre a compra com Apple Pay.
                subtitleSecondary: 'Para cartão de banco que não avisa',
            },
            ios_quick_manual: {
                title: 'Dois toques',
                subtitle: 'Toque atrás e informe o valor',
                steps: [
                    'Em Ajustes › Acessibilidade › Toque › Tocar Atrás, escolha Toque Duplo.',
                    'Selecione o atalho “Capturar No Kontto”.',
                    'Dê dois toques atrás do iPhone para informar o gasto.',
                ],
            },
            ios_bank_notification: {
                title: 'Apps de banco',
                subtitle: 'Pix e compras pela notificação do banco',
            },
        },
        actions: {
            addShortcut: 'Adicionar ao Atalhos',
            addShortcutAgain: 'Adicionar de novo',
            updateShortcut: 'Atualizar atalho',
            retryVerify: 'Já instalei, tentar de novo',
            retryVerifyUpdated: 'Já atualizei, verificar de novo',
            markConfigured: 'Já configurei',
            manage: 'Gerenciar',
            openShortcuts: 'Abrir Atalhos',
            viewPending: 'Pendências',
        },
        notes: {
            installFirst: 'Instale o atalho para usar Dois toques. Apple Pay pode ser configurado separadamente.',
            shortcutNeeded: 'Dois toques precisa do atalho acima. Apple Pay funciona separadamente.',
            waitingBecomesActive: 'O status muda para Ativo após a primeira captura real.',
            reviewPending: 'Confira antes de entrar no saldo',
            systemSetupTitle: 'Por que existe uma configuração?',
            systemSetupBody: 'O iOS exige que você autorize a automação da Carteira e escolha o gesto. O Kontto publica as ações, mas não pode ativar essas opções sozinho.',
            walletSetupBody: 'Por segurança, o iOS só permite que você crie esta automação. É uma configuração única; depois, cada compra roda sozinha.',
            simulator: 'Apple Pay e Dois toques não disparam no Simulator. O teste acima valida a mesma inbox usada pelas ações reais.',
        },
        toasts: {
            setupFailed: 'Não foi possível salvar. Tente de novo.',
            shortcutFailed: 'Não foi possível abrir o Atalhos',
        },
    },
    appearance: {
        sections: {
            theme: 'Tema',
            accentColor: 'Cor de destaque',
            addButton: 'Botão de adicionar',
        },
        coloredFab: {
            title: 'Botão + colorido',
            description: 'Pinta o botão de adicionar com a cor de destaque do tema.',
            proBadge: 'PRO',
        },
        save: {
            getPro: 'Obter Pro',
            saveTheme: 'Salvar tema',
            success: 'Tema salvo!',
        },
    },
    security: {
        status: {
            onTitle: 'Kontto protegido',
            onSubtitle: 'Abre com {{methods}} · trava após {{minutes}} min',
            methodPin: 'PIN',
            methodPinBiometric: 'PIN ou {{biometric}}',
            offTitle: 'Kontto sem trava',
            offBadge: 'Desativado',
            offBody: 'Sem PIN, quem estiver com o aparelho desbloqueado na mão abre o Kontto e vê suas contas, cartões e lançamentos.',
        },
        groups: {
            access: 'Como desbloquear',
            autoLock: 'Bloqueio automático',
        },
        actions: {
            createPin: 'Criar PIN',
            changePin: 'Alterar PIN',
            removePin: 'Remover PIN',
            cancel: 'Cancelar',
        },
        biometric: {
            title: 'Desbloquear com {{biometric}}',
            description: 'Vale só neste aparelho — o PIN continua como alternativa.',
        },
        changePin: {
            description: 'Confirme o PIN atual antes de escolher o novo.',
        },
        removePin: {
            description: 'O app volta a abrir sem pedir nada.',
        },
        autoLock: {
            minutesOption: '{{minutes}} min',
            title: 'Pedir o PIN de novo',
            subtitle: 'Tempo com o app fechado ou em segundo plano até o Kontto travar sozinho.',
            hint: 'Voltando antes de {{minutes}} min, o app abre direto.',
        },
        lockOnColdStart: {
            title: 'Sempre pedir o PIN ao abrir',
            description: 'App fechado, por você ou pelo sistema, pede o PIN ao abrir — mesmo antes do tempo acima. Só trocar de app e voltar segue o tempo.',
        },
        footerNote: 'O PIN fica guardado só neste aparelho, no cofre do sistema — o Kontto não tem cópia e não consegue recuperá-lo. Mantenha um backup dos seus dados.',
        flows: {
            setup: { title: 'Criar PIN', subtitle: 'Digite um PIN de 4 dígitos' },
            setupConfirm: { title: 'Confirmar PIN', subtitle: 'Digite o mesmo PIN novamente' },
            changeVerify: { title: 'PIN atual', subtitle: 'Confirme seu PIN para continuar' },
            changeNew: { title: 'Novo PIN', subtitle: 'Digite o novo PIN de 4 dígitos' },
            changeConfirm: { title: 'Confirmar novo PIN', subtitle: 'Digite o novo PIN novamente' },
            removeVerify: { title: 'Remover PIN', subtitle: 'Confirme seu PIN para remover' },
            biometricVerify: { title: 'Confirmar PIN', subtitle: 'Confirme seu PIN para alterar biometria' },
        },
        toasts: {
            pinCreated: 'PIN criado',
            pinChanged: 'PIN alterado',
            pinRemoved: 'PIN removido',
            biometricEnabled: 'Biometria ativada',
            biometricEnabledDescription: 'A biometria vale apenas neste aparelho.',
            biometricDisabled: 'Biometria desativada',
            biometricDisabledDescription: 'O desbloqueio volta a depender só do PIN deste aparelho.',
        },
        errors: {
            pinMismatch: 'PINs não coincidem',
            pinIncorrect: 'PIN incorreto',
            validationFailed: 'Falha ao validar o PIN',
        },
    },
    preferences: {
        hub: {
            searchPlaceholder: 'Buscar ajuste',
            noResults: 'Nenhum ajuste com “{{query}}”.',
            changedBanner: {
                prefix: 'Você mudou ',
                count_one: '{{count}} ajuste',
                count_other: '{{count}} ajustes',
                suffix: ' dos padrões do Kontto.',
                action: 'Ver',
            },
            summary: {
                and: ' e ',
                andMore: ' e mais {{count}}',
                allOff: 'Tudo desligado',
            },
        },
        groups: {
            statement: 'Extrato',
            balance: 'Saldo e Home',
            analysis: 'Análise e relatórios',
            entries: 'Lançar e atalhos',
            haptics: 'Vibração',
            region: 'Idioma, moeda e datas',
        },
        // Pedaços do subtítulo de cada grupo no hub: o estado em palavras, em minúsculas
        // (a primeira letra do resumo sobe no código).
        summary: {
            categoryLabel: {
                category: 'categoria',
                subcategory: 'subcategoria',
                both: 'categoria › subcategoria',
            },
            showTagsInStatement: 'tags',
            showNotesInStatement: 'observação',
            showTransactionTime: 'hora',
            showPeriodBalance: 'saldo do período',
            showDailyRunningBalance: 'saldo do dia',
            pendingOnTop: 'pendentes em destaque',
            overdueInCurrentMonth: 'atrasadas no mês atual',
            showReservaMovementsInStatement: 'caixinhas',
            separateCardPurchases: 'compras do cartão separadas',
            onlyConfirmedTransactions: 'só efetivadas',
            includeReceivablesInBalance: '“quem me deve” no saldo',
            standaloneMonthlyForecast: 'saldo previsto por mês',
            monthResultInCurrentMonth: 'resultado no mês atual',
            monthStartDay: 'mês do dia {{day}}',
            showAccountReserved: 'reservado nas contas',
            installmentsMonthly: 'parcelas mês a mês',
            installmentsFullValue: 'parcelas pelo valor total',
            invoicesByDueMonth: 'fatura no vencimento',
            invoicesByClosingMonth: 'fatura no fechamento',
            pocketQuickAction: 'caixinha no “+”',
            numericKeypad: 'teclado numérico',
            calculatorKeypad: 'teclado de cálculo',
            hapticsOff: 'desligada',
            hapticsExceptTabs: 'ligada, exceto ao trocar de aba',
            hapticsWithTabs: 'ligada, inclusive ao trocar de aba',
        },
        // Linhas das subtelas. Título curto (o grupo já dá o contexto) e dica só onde o
        // efeito não é óbvio — a prévia do topo mostra o resto.
        rows: {
            statementCategoryLabel: { title: 'Categoria nas transações' },
            showTagsInStatement: { title: 'Tags' },
            showNotesInStatement: { title: 'Observação' },
            showTransactionTime: { title: 'Hora', hint: 'Também habilita o campo de hora ao lançar.' },
            showPeriodBalance: { title: 'Saldo do período', hint: 'Resumo no topo e resultado de cada dia.' },
            showDailyRunningBalance: { title: 'Saldo acumulado por dia', hint: 'Some com busca ou filtros ativos.' },
            runningBalanceIncludesOpening: { title: 'Incluir saldo anterior' },
            pendingOnTop: { title: 'Pendentes em destaque' },
            overdueInCurrentMonth: {
                title: 'Atrasadas no mês atual',
                hint: 'Pendentes de meses anteriores no topo das Transações e em Pagar e Receber.',
            },
            showReservaMovementsInStatement: {
                title: 'Caixinhas no extrato',
                hint: 'Guardar e resgatar aparecem como linha cinza. Não mudam os totais.',
            },
            separateCardPurchases: {
                title: 'Compras do cartão separadas',
                hint: 'Lista cada compra em vez de agrupar na fatura.',
            },
            onlyConfirmedTransactions: { title: 'Apenas efetivadas', hint: 'Esconde pendentes e projeções.' },
            monthStartDay: {
                title: 'Início do mês',
                hint: 'Para quem controla de salário a salário. As telas passam a mostrar o período, como “20 de out – 19 de nov”.',
                valueCalendar: 'Dia 1 · calendário',
                valueDay: 'Dia {{day}}',
                sheetTitle: 'Início do mês',
                sheetHint: 'Cada mês vai do dia escolhido até a véspera dele no mês seguinte. Em mês mais curto, começa no último dia. Vale para todo o histórico: o Balanço dos meses passados é refeito.',
                applyToBudgets: {
                    title: 'Aplicar aos orçamentos?',
                    message_one: '{{count}} orçamento mensal começa no dia {{previousDay}}. Quer que ele passe a começar no dia {{day}} também?',
                    message_other: '{{count}} orçamentos mensais começam no dia {{previousDay}}. Quer que eles passem a começar no dia {{day}} também?',
                    apply: 'Aplicar',
                    skip: 'Agora não',
                },
            },
            includeReceivablesInBalance: {
                title: 'Incluir “quem me deve” no saldo',
                hint: 'Projeções seguem só com o caixa.',
            },
            standaloneMonthlyForecast: { title: 'Saldo previsto por mês', hint: 'Vale nos meses futuros.' },
            monthResultInCurrentMonth: {
                title: 'Também no mês atual',
                hint: 'O topo mostra receitas menos despesas em vez do saldo que está na conta.',
            },
            showAccountReserved: { title: 'Reservado nas contas' },
            installmentsFullValue: {
                title: 'Parcelamentos pelo valor total',
                hint: 'Fatura e extrato seguem mostrando cada parcela.',
            },
            invoicesByClosingMonth: {
                title: 'Cartão no mês de fechamento',
                hint: 'Para cartão que fecha no fim do mês e vence no mês seguinte.',
            },
            calculatorKeypad: {
                title: 'Teclado de cálculo',
                hint: 'Desligado, a calculadora segue a um toque no ícone.',
            },
            showPocketQuickAction: { title: 'Caixinha no botão “+”' },
            hapticsEnabled: { title: 'Vibração no app' },
            tabHapticsEnabled: { title: 'Vibrar ao trocar de aba' },
            language: { title: 'Idioma' },
            currency: { title: 'Moeda', hint: 'Só muda o símbolo — valores não são convertidos.' },
            dateFormat: { title: 'Formato de data' },
        },
        changed: {
            title: 'Fora do padrão',
            subtitle_one: '{{count}} ajuste diferente do Kontto',
            subtitle_other: '{{count}} ajustes diferentes do Kontto',
            on: 'Ligado',
            off: 'Desligado',
            day: 'Dia {{day}}',
            restore: 'Restaurar',
            restoreAccessibility: 'Restaurar o padrão de {{title}}',
            othersNote_one: 'O outro ajuste está como o Kontto entrega. Idioma, moeda e formato de data não entram nesta lista.',
            othersNote_other: 'Os outros {{count}} ajustes estão como o Kontto entrega. Idioma, moeda e formato de data não entram nesta lista.',
            empty: 'Tudo como o Kontto entrega.',
            emptyNote: 'Idioma, moeda e formato de data não entram nesta lista.',
            restoreAll: 'Restaurar todos os padrões',
            confirm: {
                title: 'Restaurar os padrões?',
                message: 'Os ajustes desta lista voltam a ser como o Kontto entrega. Idioma, moeda e formato de data ficam como estão.',
                confirm: 'Restaurar',
            },
        },
        // Prévias do topo das subtelas: exemplos fixos que reagem às chaves.
        preview: {
            label: 'Prévia',
            statement: {
                title: 'Nas Transações',
                food: 'Alimentação',
                delivery: 'Delivery',
                transport: 'Transporte',
                rideApp: 'App de transporte',
                power: 'Conta de luz',
                internet: 'Internet',
                housing: 'Moradia',
                utilities: 'Energia',
                tag: 'almoço',
                note: 'rachei com a Ana',
                reserva: 'Reserva de emergência',
            },
            balance: {
                title: 'Na Home',
                thisMonth: 'Este mês',
                nextMonth: 'Mês que vem',
            },
            analysis: {
                title: 'Despesas por mês',
                selected: 'Agosto',
                months: {
                    m1: 'jun',
                    m2: 'jul',
                    m3: 'ago',
                    m4: 'set',
                },
            },
        },
        // Textos longos de cada ajuste do extrato: a tela Exibição dos filtros
        // (app/transactions/filters-display.tsx) usa estes, com a explicação completa no ⓘ.
        statement: {
            categoryLabel: {
                title: 'Categoria nas transações',
                description: 'O que aparece abaixo do nome de cada lançamento na lista. Sem subcategoria, mostra a categoria.',
                options: {
                    category: 'Categoria',
                    subcategory: 'Subcategoria',
                    both: 'Ambas',
                },
            },
            tags: {
                title: 'Tags nas transações',
                description: 'Mostra as tags de cada lançamento direto na lista.',
            },
            notes: {
                title: 'Observação nas transações',
                description: 'Mostra a nota/observação de cada lançamento direto na lista.',
            },
            time: {
                title: 'Hora nos lançamentos',
                description: 'Mostra o campo de hora ao criar/editar e a hora nas listas. Lançamento de hoje sem hora escolhida grava a hora atual.',
            },
            separateCardPurchases: {
                title: 'Compras do cartão separadas',
                description: 'Lista cada compra do cartão em vez de agrupar na fatura.',
            },
            onlyConfirmed: {
                title: 'Apenas efetivadas',
                description: 'Esconde pendentes e projeções; cartão entra só com fatura paga.',
            },
            periodBalance: {
                title: 'Saldo do período',
                description: 'Resumo de saída, entrada e saldo no topo das Transações, do mês ou da busca.',
            },
            dailyBalance: {
                title: 'Saldo acumulado por dia',
                description: 'Disponível das contas (já sem o reservado das caixinhas) ao fim de cada dia no extrato, como num extrato bancário. Some com busca ou filtros ativos.',
            },
            dailyBalanceOpening: {
                title: 'Incluir saldo anterior',
                description: 'Parte do saldo herdado do mês anterior. Desligado, o acumulado começa do zero no dia 1º.',
            },
            reservaMovements: {
                title: 'Caixinhas no extrato',
                description: 'Mostra guardar e resgatar das caixinhas no extrato da conta e nas Transações, como linhas informativas. Não mudam os totais.',
            },
            pendingOnTop: {
                title: 'Pendentes em destaque',
                description: 'Mantém pendentes e projeções no topo da lista. Desligado, a lista fica em ordem cronológica por dia.',
            },
            overdueInCurrentMonth: {
                title: 'Atrasadas no mês atual',
                description: 'Lançamentos pendentes de meses anteriores aparecem no topo das Transações do mês atual e entram em Pagar e Receber, nas Pendências da Home.',
            },
        },
    },
    appIcon: {
        explainer: 'Deixe o Kontto com a sua cara. Toque num ícone pra aplicar.',
        itemAccessibility: 'Ícone {{label}}',
        itemAccessibilityCurrent: 'Ícone {{label}} (atual)',
        applyError: {
            title: 'Não foi possível trocar o ícone',
            description: 'A troca de ícone só funciona no app instalado (não no Expo Go).',
        },
        applied: {
            androidTitle: 'Quase lá!',
            androidDescription: 'Aperte Home pra sair do Kontto — o novo ícone aparece na tela inicial. Ao reabrir, você volta aqui.',
            iosTitle: 'Ícone atualizado',
            iosDescription: 'Pronto! O novo ícone já está na sua tela inicial.',
        },
        androidNote: 'No Android, o ícone novo aparece quando você fecha ou minimiza o app — e pode piscar/sumir por um instante na tela inicial. É comportamento normal do sistema.',
        confirmDialog: {
            title: 'Trocar o ícone do app?',
            message: 'Pra aplicar o ícone {{label}}, saia do Kontto (botão Home) — o novo ícone aparece na tela inicial. Ao reabrir, você volta direto aqui.',
            confirm: 'Trocar',
            cancel: 'Agora não',
        },
    },
    homeLayout: {
        explainer: 'Arraste pelo punho para reordenar os blocos da sua tela inicial e toque no olho para mostrar ou esconder. A navegação de mês e o saldo ficam sempre no topo.',
        // Anexado ao explainer com um espaço (só sem Pro).
        explainerProSuffix: 'Reordenar e mostrar/esconder é um recurso do Kontto Pro.',
        configureShortcuts: 'Configurar atalhos',
        restoreDefault: 'Restaurar padrão',
    },
    // Vaga personalizável da tab bar (ADR 0122).
    tabSlot: {
        explainer: 'Escolha o que abre no quarto botão da barra. O que sair da barra vai pra aba Mais.',
        // Anexado ao explainer com um espaço (só sem Pro).
        explainerProSuffix: 'Trocar o atalho é um recurso do Kontto Pro.',
        livePreview: 'Prévia ao vivo',
        previewPill: 'Quarto botão · {{label}}',
        defaultHint: 'padrão',
        save: 'Salvar atalho',
        saved: 'Quarto botão agora abre {{label}}',
        quickTitle: 'Atalho da barra',
        quickSeeAll: 'Ver todos',
        quickClose: 'Fechar',
        short: { cashFlow: 'Fluxo', goals: 'Metas', financings: 'Financ.' },
    },
    analysisLayout: {
        explainer: 'Arraste pelo punho para reordenar os blocos da aba Análise e toque no olho para mostrar ou esconder. O navegador de mês e o seletor de visão ficam sempre no topo.',
        // Anexado ao explainer com um espaço (só sem Pro).
        explainerProSuffix: 'Reordenar, mostrar/esconder e os gráficos extras são recursos do Kontto Pro.',
        restoreDefault: 'Restaurar padrão',
        sections: {
            overview: 'Resumo do mês',
            categories: 'Gastos por categoria',
            monthlyFlow: 'Fluxo mensal',
            netWorth: 'Patrimônio',
            spendingPace: 'Ritmo de gasto',
            topExpenses: 'Maiores gastos',
            savingsRate: 'Taxa de poupança',
            weekday: 'Gastos por dia da semana',
            fixedVariable: 'Fixas e variáveis',
            reportsLink: 'Relatórios avançados',
        },
    },
    homeShortcuts: {
        explainer: 'Escolha os atalhos da sua tela inicial. Arraste pelo punho para ordenar e toque na lixeira para remover.',
        // Anexado ao explainer com um espaço (só sem Pro).
        explainerProSuffix: 'Escolher e ordenar atalhos é um recurso do Kontto Pro.',
        empty: 'Nenhum atalho na home ainda. Adicione abaixo.',
        addSectionTitle: 'Adicionar',
        restoreDefault: 'Restaurar padrão',
    },
    // app/settings/ai.tsx — Assistente IA (BYOK)
    ai: {
        explainer: 'Conecte sua própria chave de IA — grátis no Kontto. Ela vai direto do aparelho pro provedor; nada passa por servidores nossos.',
        providerLabel: 'Provedor',
        // Legenda dentro de cada card de provedor: o argumento que decide a escolha.
        providerOptions: {
            gemini: { description: 'Google · tem nível gratuito' },
            openai: { description: 'Exige créditos ativos' },
            openrouter: { description: 'Vários modelos, uma chave só' },
        },
        apiKeyLabel: 'Chave de API',
        dataSharingLabel: 'Compartilhamento de dados',
        // Uma chave por provedor em vez de interpolar a marca: em pt-BR a preposição
        // concorda com o nome ("do Gemini" / "da OpenAI").
        helpLink: {
            gemini: 'Como obter a chave do Gemini?',
            openai: 'Como obter a chave da OpenAI?',
            openrouter: 'Como obter a chave do OpenRouter?',
        },
        // Campo extra que só o OpenRouter mostra: o catálogo é o atrativo do provedor,
        // então o modelo é escolha do usuário — com a cadeia padrão de rede de segurança.
        openrouterModel: {
            label: 'Modelo (opcional)',
            placeholder: 'Buscar modelo',
            hint: 'Toque no campo pra ver o catálogo — os gratuitos aparecem primeiro. Vazio, o Kontto usa um modelo rápido e barato.',
            free: 'Grátis',
            // Preço de ENTRADA por 1M de tokens, direto do catálogo — referência, não fatura.
            pricePerM: 'US$ {{price}}/M',
            catalogError: 'Não deu pra carregar o catálogo de modelos. Você ainda pode digitar o ID manualmente.',
            retry: 'Tentar de novo',
        },
        // Faixa que substitui o explicador quando já existe chave salva.
        connected: {
            title: 'IA ativa com {{provider}}',
            subtitle: 'Toque em "Testar conexão" para conferir a chave.',
            validated: 'Conexão validada agora há pouco.',
        },
        status: {
            validated: 'Conexão validada com sucesso.',
            failed: 'Falha ao testar a conexão.',
        },
        testButton: 'Testar conexão',
        testingButton: 'Testando...',
        saveButton: 'Salvar',
        savingButton: 'Salvando...',
        keyNote: 'A chave fica salva só neste aparelho.',
        legacyGeminiKey: {
            title: 'Sua chave antiga expira em setembro',
            description: 'Gere uma nova no Google AI Studio (formato "AQ.") e cole aqui.',
            action: 'Como gerar uma chave nova',
        },
        removeKey: {
            action: 'Remover chave',
            confirmTitle: 'Remover a chave?',
            confirmMessage: 'A IA para de funcionar até você colar outra. A chave é apagada só deste aparelho — nada muda na sua conta do provedor.',
            confirmLabel: 'Remover',
            toast: 'Chave removida',
        },
        dataSharing: {
            description: 'Você autorizou o envio de dados à IA (o resumo financeiro das análises ou as descrições da fatura que pediu para categorizar). Pode revogar a qualquer momento — as análises voltam a ser geradas localmente e a fatura volta a ser categorizada só no aparelho.',
            revoke: 'Revogar autorização',
        },
        toasts: {
            aiDisabled: 'IA desativada',
            saved: 'Configurações salvas',
            saveFailed: 'Falha ao salvar',
            insertKeyFirst: 'Insira uma API key primeiro',
        },
    },
    // components/settings/ApiKeyHelpSheet.tsx — passo a passo por provedor
    apiKeyHelp: {
        gemini: {
            title: 'Como obter a chave do Gemini',
            intro: 'Leva uns 2 minutos e o nível gratuito costuma bastar.',
            urlLabel: 'Abrir Google AI Studio',
            keyHint: 'Chaves novas começam com "AQ." e antigas com "AIza" — as duas funcionam.',
            step1: 'Entre no Google AI Studio com sua conta Google.',
            step2: 'Toque em "Criar chave de API" (Create API key).',
            step3: 'Escolha um projeto — novo ou existente.',
            step4: 'Copie a chave e cole aqui no campo.',
        },
        openai: {
            title: 'Como obter a chave da OpenAI',
            intro: 'A API exige créditos/billing ativos na sua conta.',
            urlLabel: 'Abrir OpenAI Platform',
            keyHint: 'A chave começa com "sk-".',
            step1: 'Entre na sua conta em platform.openai.com.',
            step2: 'Em "API keys", toque em "Create new secret key".',
            step3: 'Copie na hora — ela só aparece uma vez.',
            step4: 'Cole aqui no campo de chave.',
        },
        openrouter: {
            title: 'Como obter a chave do OpenRouter',
            intro: 'Uma chave dá acesso a centenas de modelos — alguns gratuitos, os demais com créditos pré-pagos.',
            urlLabel: 'Abrir OpenRouter',
            keyHint: 'A chave começa com "sk-or-".',
            step1: 'Crie uma conta em openrouter.ai (dá pra entrar com Google).',
            step2: 'Em "Keys", toque em "Create Key".',
            step3: 'Copie a chave e cole aqui no campo.',
            step4: 'Opcional: escolha um modelo do catálogo no campo "Modelo".',
        },
    },
    // app/settings/backup.tsx — tela principal de Backup (redesign "Backup - Final")
    backup: {
        // Faixa do build sem Drive (S0) e o problema do backup parado (S3) — ADR 0193.
        status: {
            unavailableTitle: 'Backup na nuvem',
            unavailableSubtitle: 'Disponível após atualizar o app (novo build).',
            stoppedTitle: 'O backup parou',
            reconnectAction: 'Reconectar',
            reconnecting: 'Reconectando...',
        },
        errors: {
            driveNeedsUpdate: 'O backup no Google Drive não funciona nesta versão do app. Atualize o Kontto na loja para voltar a fazer backup.',
        },
        syncCard: {
            beta: 'Beta',
            syncing: 'Sincronizando...',
            reset: 'Redefinir sincronização',
            resetSub: 'Se ninguém lembra a senha usada ao ligar',
            forgotRow: 'Esqueci a senha do outro aparelho',
            mismatchTitle: 'A senha não bate com a do outro aparelho',
            mismatchBody: 'A sincronização foi ligada em outro aparelho com outra senha de proteção. Digite a mesma senha usada lá.',
            mismatchRetry: 'Tentar de novo',
        },
        restorePoints: {
            title: 'Restaurar',
            checking: 'Verificando...',
        },
        toasts: {
            connectFailed: 'Não foi possível conectar',
            connected: 'Google Drive conectado',
            sendFailed: 'Falha ao enviar',
            noDestinationTitle: 'Escolha um destino',
            noDestinationBody: 'Conecte o Google Drive ou escolha uma pasta do aparelho.',
            folderChosen: 'Pasta escolhida',
            folderChooseFailed: 'Falha ao escolher a pasta',
            folderManualOnlyTitle: '{{folder}}: só backup manual',
            folderManualOnlyBody: 'Essa nuvem não aceita backup automático. Escolha uma pasta do aparelho para o automático.',
            folderSaveFailed: 'Falha ao salvar na pasta',
            folderShareTitle: 'Backup pronto para salvar',
            folderShareBody: 'Escolha {{folder}} no compartilhamento para guardar o arquivo cifrado.',
            wrongPassTitle: 'Senha incorreta',
            wrongPassBody: 'Use a mesma senha da Proteção por senha, igual nos dois aparelhos.',
            syncEnabled: 'Sincronização ativada',
            // Sem contagem de propósito: o ciclo conta mensagens por campo, não lançamentos (ADR 0146).
            syncReceived: 'Os dados do outro aparelho chegaram.',
            syncResultBoth: 'Suas mudanças foram enviadas e as do outro aparelho chegaram.',
            syncResultSent: 'Suas mudanças foram enviadas.',
            syncResultReceived: 'Chegaram mudanças do outro aparelho.',
            syncResultNothing: 'Já estava tudo em dia.',
            syncFirstFailed: 'Ativado, mas a 1ª sincronização falhou',
            syncResetDone: 'Sincronização redefinida',
            syncResetDoneBody: 'Este aparelho é a base agora. Nos outros, abra o Kontto e digite esta mesma senha de proteção.',
            syncResetCycleFailed: 'Redefinida, mas o 1º envio falhou',
            syncResetFailed: 'Não deu para redefinir',
            rejoinBackupFailed: 'Não deu para salvar o ponto de restauração',
            rejoinMismatch: 'Não é a senha usada no outro aparelho',
            enableFailed: 'Falha ao ativar',
            joinFailed: 'Falha ao entrar no espaço',
            synced: 'Sincronizado',
            syncFailed: 'Falha ao sincronizar',
            protectionRemoved: 'Proteção removida',
            protectionRemovedAndroid: 'Backups voltam a ser em arquivo aberto. Backup automático (pasta e Drive) e sincronização foram desligados — eles exigem senha.',
            protectionRemovedIos: 'Backups voltam a ser em arquivo aberto. Backup automático no Drive e sincronização foram desligados — eles exigem senha.',
            removeFailed: 'Falha ao remover',
            encryptFailed: 'Falha ao cifrar',
            encryptedReadyTitle: 'Backup cifrado pronto',
            encryptedReadyBody: 'Protegido por senha e pronto para compartilhar.',
            readyTitle: 'Backup pronto',
            readyBody: 'Preparado para compartilhamento local.',
            createFailed: 'Falha ao criar backup',
        },
        removeDialog: {
            title: 'Remover proteção por senha',
            message: 'Os próximos backups voltam a ser em arquivo aberto (JSON).\n\nBackups já criados com senha continuam exigindo a senha para restaurar.',
            confirm: 'Remover',
        },
        changeAccountDialog: {
            title: 'Trocar conta Google',
            message: 'Os backups continuam na conta atual — nada é apagado.\n\nVamos desconectar e abrir o login do Google para você escolher outra conta.',
            confirm: 'Trocar conta',
        },
        joinDialog: {
            title: 'Substituir os dados deste aparelho',
            message: 'Este Drive já tem dados sincronizados de outro aparelho.\n\nPara entrar na sincronização, os dados DESTE aparelho serão substituídos pelos do outro — eles não se misturam. Se quiser guardar o que está aqui, exporte um backup antes.\n\nNada é alterado se você cancelar.',
            confirm: 'Substituir e sincronizar',
        },
        // Assistente do "Ativar" (ADR 0193): Google, depois a senha, e no fim backup + sync ligados.
        setup: {
            hero: {
                title: 'Guarde seus dados no Drive',
                subtitle: 'Ligue uma vez. O resto acontece sozinho.',
                daily: 'Uma cópia por dia, sem você lembrar',
                devices: 'Os mesmos dados no celular e no tablet',
                locked: 'Trancado com uma senha só sua',
                cta: 'Ativar',
                proNote: 'Recurso do Kontto Pro. Restaurar continua grátis.',
            },
            step: '{{current}} de {{total}}',
            stepA11y: 'Passo {{current}} de {{total}}',
            google: {
                title: 'Entre com sua conta Google',
                body: 'Seus dados ficam numa pasta do Kontto no seu Drive, trancados. Nem o Google nem o Kontto conseguem ler.',
                cta: 'Continuar com Google',
                checking: 'Conferindo seu Drive…',
                later: 'Agora não',
            },
            create: {
                title: 'Crie sua senha de proteção',
                titleNew: 'Crie uma senha nova',
                body: 'Você vai usar esta mesma senha nos outros aparelhos. Sem ela, ninguém recupera os dados.',
                match: 'As senhas conferem',
                cta: 'Ativar',
            },
            found: {
                title: 'Encontramos seus dados',
                body: 'Última cópia {{when}}. Digite a senha de proteção que você usa no outro aparelho.',
                bodyNoDate: 'Digite a senha de proteção que você usa no outro aparelho.',
                wrong: 'Não é essa. Use a mesma senha do outro aparelho.',
                replaceNote: 'O que já está neste aparelho é trocado pelo do Drive.',
                cta: 'Trazer meus dados',
                forgot: 'Esqueci a senha',
            },
            unlock: {
                title: 'Digite sua senha de proteção',
                body: 'A mesma que você criou neste aparelho.',
                wrong: 'Senha incorreta.',
                cta: 'Ativar',
            },
            field: {
                password: 'Senha',
                confirm: 'Confirmar senha',
                show: 'Mostrar senha',
                hide: 'Ocultar senha',
            },
            working: {
                title: 'Ligando a proteção',
                body: 'Leva alguns segundos. Pode deixar o app aberto.',
                pass: 'Senha criada',
                sync: 'Ligando a sincronização',
                firstCopy: 'Primeira cópia no Drive',
            },
            done: {
                title: 'Tudo pronto',
                body: 'Seus dados estão no Drive e vão se manter iguais nos seus aparelhos.',
            },
        },
        // Painel "Tudo protegido" e a lista da tela (ADR 0193).
        panel: {
            okTitle: 'Tudo protegido',
            okBoth: 'Backup e sincronização ligados',
            okBackupOnly: 'Backup ligado · sincronização desligada',
            okSyncOnly: 'Sincronização ligada · backup desligado',
            okFolderOnly: 'Backup na pasta do aparelho',
            lastCopy: 'Última cópia',
            synced: 'Sincronizado',
            notYet: 'ainda não',
            today: 'hoje, {{time}}',
            yesterday: 'ontem, {{time}}',
            saveNow: 'Salvar agora',
            saving: 'Salvando…',
            saved: 'Salvo',
            offTitle: 'Proteção desligada',
            offSubtitle: 'Nada foi apagado',
            offCta: 'Ligar de novo',
            pausedTitle: 'Sincronização pausada',
            pausedSubtitle: 'Foi redefinida em outro aparelho',
            pausedBody: 'Digite a senha usada lá para voltar. Antes, guardamos uma cópia dos dados daqui.',
            pausedCta: 'Digitar a senha',
            pausedUseAsBase: 'Usar este aparelho como base',
            failingTitle: 'A sincronização falhou',
            failingCta: 'Tentar de novo',
            needsKeyBody: 'Este aparelho precisa da senha de proteção para voltar a sincronizar.',
            tipTitle: 'Agora, no outro aparelho',
            tipBody: 'Abra o Kontto, toque em Ativar, entre com {{email}} e use esta mesma senha.',
            tipDismissA11y: 'Fechar dica',
            rowOtherDevice: 'Usar em outro aparelho',
            rowOtherDeviceSub: 'Mesma conta Google e mesma senha',
            rowAccount: 'Conta Google',
            rowPassword: 'Senha de proteção',
            rowPasswordSub: 'Pedida em cada aparelho novo',
            rowPasswordRemove: 'Remover a senha de proteção',
            rowMore: 'Mais opções',
            rowMoreSubOff: 'Pasta do aparelho, exportar arquivo',
            rowMoreSub: 'Sincronização, pasta, exportar',
            restoreFallback: 'De um arquivo ou de um ponto salvo',
            restoreCount_one: '{{count}} ponto salvo',
            restoreCount_other: '{{count}} pontos salvos',
        },
        otherDevice: {
            title: 'Usar em outro aparelho',
            body: 'Leva um minuto. Os dados chegam sozinhos.',
            step1: 'Abra o Kontto no outro aparelho',
            step1Sub: 'Configurações › Backup e Sync',
            step2: 'Toque em Ativar',
            step2Sub: 'Entre com {{email}}',
            step3: 'Digite a mesma senha de proteção',
            step3Sub: 'A mesma usada neste aparelho',
            cta: 'Entendi',
        },
        // Rota "Mais opções" (app/settings/backup-more.tsx).
        more: {
            sectionSync: 'Sincronização',
            syncSwitch: 'Sincronizar aparelhos',
            syncOn: 'Ligada · {{when}}',
            syncOff: 'Desligada',
            sectionCopies: 'Outras cópias',
            folder: 'Também salvar numa pasta do aparelho',
            folderNone: 'Nenhuma pasta escolhida',
            folderManualOnly: '{{folder}} guarda só backup manual. Para o automático, escolha uma pasta do aparelho.',
            export: 'Exportar arquivo',
            exporting: 'Exportando…',
            exportSub: 'Uma cópia trancada para guardar onde quiser',
            sectionOff: 'Desligar',
            turnOff: 'Desligar backup e sincronização',
            turnOffSub: 'Nada é apagado do Drive nem deste aparelho',
            turnOffDialog: {
                title: 'Desligar a proteção?',
                message: 'O backup diário e a sincronização param neste aparelho. Nada é apagado do Drive nem daqui. Para ligar de novo, você digita a senha.',
                confirm: 'Desligar',
            },
        },
        resetSyncSheet: {
            title: 'Redefinir a sincronização?',
            subtitle: 'Use quando ninguém lembra a senha usada ao ligar a sincronização.',
            baseTitle: 'Este aparelho vira a base',
            baseBody: 'Os dados daqui passam a valer em todos os aparelhos.',
            keepTitle: 'Nada é apagado aqui',
            keepBody: 'Nem os pontos de restauração no Drive.',
            othersTitle: 'Os outros aparelhos pedem a senha daqui',
            othersBody: 'Ao voltar, recebem estes dados. Cada um salva um ponto de restauração antes.',
            warning: 'Faça isto no aparelho com os dados mais completos, e atualize o Kontto nos outros antes.',
            cancel: 'Cancelar',
            confirm: 'Continuar',
            footnote: 'Depois pedimos a senha de proteção deste aparelho.',
            footnoteNew: 'Depois você cria uma senha nova.',
        },
        rejoinSyncDialog: {
            title: 'Receber os dados do outro aparelho',
            message: 'A sincronização foi redefinida em outro aparelho. Para voltar, os dados DESTE aparelho são trocados pelos de lá.\n\nAntes, um ponto de restauração com os dados daqui é salvo no Google Drive.\n\nSe este aparelho tem os dados mais completos, cancele e toque em "Redefinir sincronização" aqui.',
            confirm: 'Receber os dados',
        },
    },
    // app/settings/backups.tsx — Pontos de restauração (2b)
    backups: {
        warnNote: 'Restaurar substitui toda a base local atual.',
        driveSection: 'Na sua conta Google',
        folderSection: 'Neste aparelho',
        loadingVersions: 'Carregando versões...',
        driveEmpty: 'Nenhum ponto de restauração ainda.',
        folderEmpty: 'Nenhuma versão na pasta.',
        rotationNote: 'Guardamos os {{keepVersions}} pontos mais recentes. Ao criar um novo, o mais antigo sai automaticamente.',
        emptyState: 'Nenhum backup guardado ainda. Você pode restaurar a partir de um arquivo salvo.',
        restoreFileA11y: 'Restaurar de outro arquivo',
        restoring: 'Restaurando...',
        restoreFromFile: 'Restaurar de outro arquivo…',
        sourceDrive: 'Drive',
        sourceFolder: 'Pasta',
        rowEncrypted: '{{source}} · Cifrado',
        latestBadge: 'MAIS RECENTE',
        restore: 'Restaurar',
        deletePointA11y: 'Excluir ponto de {{date}}',
        progress: {
            title: 'Restaurando seu backup',
            doneTitle: 'Backup restaurado',
            doneSubtitle: 'Tudo pronto!',
            stepDownload: 'Baixando do seu Drive...',
            stepRead: 'Lendo o arquivo...',
            stepDecrypt: 'Decifrando seus dados...',
            stepApply: 'Trazendo seus lançamentos...',
            stepFinish: 'Deixando tudo em ordem...',
            note: 'Isso leva só um instante. Não feche o app.',
            // Variante 'join' (entrar num espaço de sincronização). Mesma trava, outra palavra:
            // quem ligou o sync não pediu "restaurar backup".
            joinTitle: 'Ligando a sincronização',
            joinDoneTitle: 'Aparelhos sincronizados',
            joinDoneSubtitle: 'Tudo pronto!',
            joinStepPrepare: 'Preparando este aparelho...',
            joinStepDownload: 'Baixando os dados sincronizados...',
        },
        toasts: {
            restoredTitle: 'Backup restaurado',
            restoredSyncKeep: 'Enviado aos seus outros aparelhos. PIN e biometria continuam deste.',
            restoredSyncPending: 'PIN e biometria continuam deste. A sincronização vai completar no próximo ciclo.',
            restoredLocal: 'PIN, biometria e permissões continuam deste aparelho.',
            restoreFailed: 'Falha ao restaurar',
            pointDeleted: 'Ponto de restauração excluído',
            deleteFailed: 'Falha ao excluir',
        },
        confirm: {
            file: 'Escolha um arquivo de backup. Isso vai substituir todo o banco local atual. Essa ação não pode ser desfeita.',
            named: 'Vamos trazer o backup de {{date}}.\n\nIsso vai substituir todo o banco local atual. Essa ação não pode ser desfeita.',
            syncWarning: '⚠️ A sincronização está ligada: este estado vai substituir os dados nos SEUS OUTROS aparelhos também.',
            title: 'Restaurar backup?',
            confirmLabel: 'Substituir agora',
        },
        deleteDialog: {
            title: 'Excluir ponto de restauração?',
            message: 'O ponto de {{date}} será apagado do seu Drive.\n\nEssa ação não pode ser desfeita.',
            confirm: 'Excluir',
        },
    },
    // app/settings/maintenance.tsx — apenas as ações de produção; o bloco __DEV__ fica literal.
    maintenance: {
        title: 'Manutenção',
        subtitle: 'Ações pontuais que não apagam seus lançamentos.',
        reopenIntro: {
            label: 'Reabrir apresentação',
            description: 'Mostra de novo a mensagem de boas-vindas, sem apagar nada.',
            button: 'Abrir mensagem inicial',
        },
        reopenFirstSteps: {
            label: 'Reabrir os primeiros passos',
            description: 'Traz de volta o "Vamos começar" na Home, mesmo que você já tenha concluído, ocultado ou pulado passos. Não apaga nada.',
            button: 'Reabrir checklist',
            toast: 'Checklist liberado. Ele volta na Home se ainda houver passo pendente.',
        },
        purge: {
            label: 'Purgar registros excluídos',
            description: 'Remove em definitivo o que está na lixeira (já não aparece no app). O que ainda estiver ligado a um lançamento vivo continua guardado.',
            button: 'Purgar registros',
        },
        factory: {
            sectionTitle: 'Apagar tudo e recomeçar',
            blockLabel: 'Voltar o app ao estado de instalação',
            note: 'Apaga TUDO deste aparelho: lançamentos, contas, cartões, reservas e metas, além de PIN, chave de IA, preferências e o histórico de telas já vistas. O app volta como recém-instalado e reinicia no onboarding.\n\nSua assinatura não é cancelada — o Pro volta sozinho ao sincronizar. Esta ação não pode ser desfeita.',
            deleting: 'Apagando...',
            button: 'Apagar tudo e recomeçar',
        },
        toasts: {
            purged: 'Registros removidos',
            purgeFailed: 'Falha ao limpar',
            wiped: 'App zerado',
            wipeFailed: 'Falha ao apagar dados',
        },
        purgeDialog: {
            title: 'Purgar registros excluídos',
            message: 'Isso remove permanentemente os registros que estão na lixeira (transações, contas, categorias, etc). Uma conta ou cartão ainda ligado a um lançamento que você manteve continua guardado. Esta ação não pode ser desfeita.',
            confirm: 'Purgar',
        },
        factoryDialog: {
            title: 'Apagar tudo e recomeçar',
            message: 'Isso apaga TUDO deste aparelho — lançamentos, contas, cartões, reservas, metas, PIN, chave de IA, preferências e o histórico de telas já vistas — e reinicia o app no onboarding, como recém-instalado. Sua assinatura não é cancelada. Não dá para desfazer.',
            confirm: 'Apagar tudo',
        },
    },
    // components/settings/PassphraseDialog.tsx — criar/entrar com a senha de backup
    passphraseDialog: {
        errorMinLength: 'Use ao menos {{min}} caracteres.',
        errorMismatch: 'As senhas não conferem.',
        errorEmpty: 'Digite a senha do backup.',
        createTitle: 'Proteger backup com senha',
        enterTitle: 'Senha do backup',
        // Modo 'sync': MESMO formulário do 'enter', textos próprios. Aqui a senha não abre um
        // backup — ela deriva a chave compartilhada entre os aparelhos. Reusar os textos do
        // restore fazia o diálogo prometer "Restaurar" na hora de LIGAR a sincronização.
        syncTitle: 'Senha da sincronização',
        createSubtitle: 'Seus backups serão cifrados com esta senha. Guarde-a bem: sem ela não dá para restaurar em outro aparelho.',
        enterSubtitle: 'Digite a senha usada para cifrar este backup.',
        syncSubtitle: 'É a mesma Senha de proteção do backup. Ela precisa ser igual em todos os aparelhos.',
        busyCreateTitle: 'Protegendo seu backup',
        busyEnterTitle: 'Verificando a senha',
        busySyncTitle: 'Preparando a sincronização',
        busyCreateSubtitle: 'Gerando a chave de criptografia. Leva alguns segundos.',
        busyEnterSubtitle: 'Conferindo e abrindo o backup.',
        busySyncSubtitle: 'Gerando a chave compartilhada. Leva alguns segundos.',
        passPlaceholder: 'Senha',
        confirmPlaceholder: 'Confirmar senha',
        hint: 'Mínimo de {{min}} caracteres.',
        cancel: 'Cancelar',
        createSubmit: 'Ativar',
        enterSubmit: 'Restaurar',
        // Curto: 'Ativar sincronização' saía cortado no iPhone 17 (QA de 23/09); o título já diz o quê.
        syncSubmit: 'Ativar',
    },
    // components/settings/RuleFormSheet.tsx — formulário de regra de categorização
    ruleForm: {
        saveChanges: 'Salvar alterações',
        create: 'Criar regra',
        editTitle: 'Editar regra',
        newTitle: 'Nova regra',
        patternLabel: 'Padrão de texto',
        patternPlaceholder: 'Ex: PIX*IFOOD* | UBER*TRIP*',
        typeLabel: 'Tipo da regra',
        typeExpense: 'Despesa',
        typeIncome: 'Receita',
        categoryLabel: 'Categoria',
        categorySelectedFallback: 'Categoria selecionada',
        selectCategoryExpense: 'Selecionar categoria de despesa',
        selectCategoryIncome: 'Selecionar categoria de receita',
        priorityLabel: 'Prioridade',
        ruleActive: 'Regra ativa',
    },
    // components/settings/LiveThemePreview.tsx — mini-Home ilustrativa do carrossel de temas
    themePreview: {
        month: 'julho 2026',
        totalBalance: 'Saldo total',
        totalBalanceValue: 'R$ 12.480,55',
        income: 'Receitas',
        incomeValue: 'R$ 8.300,00',
        expense: 'Despesas',
        expenseValue: 'R$ 4.120,45',
        proBadge: 'PRO',
    },
    // app/settings/import.tsx — Importar dados (CSV/OFX/PDF/prints)
    import: {
        idle: {
            title: 'Importar dados',
            lead: 'A importação <0>soma</0> ao que já existe — não apaga nada.',
            local: 'Tudo acontece no seu aparelho',
            subtitle: 'Traga seu histórico de outro app ou do banco. A importação soma ao que já existe — não apaga nada.',
            chooseFile: 'Escolha o arquivo',
            csv: 'Importar planilha CSV',
            ofx: 'Importar extrato OFX do banco',
            pdf: 'Importar extrato em PDF do banco',
            prints: 'Importar extrato por prints (foto)',
            modelLink: 'Ver o modelo de CSV e baixar o exemplo →',
            importSection: 'Importar',
        },
        // Lista ranqueada por FIDELIDADE (ADR 0107): a ordem e as barrinhas dizem qual
        // arquivo dá o melhor resultado, em vez de deixar a escolha por conta do usuário.
        sources: {
            recommended: 'RECOMENDADO',
            ofxTitle: 'Extrato OFX',
            ofxSubtitle: 'Exporte no app do banco · o mais fiel',
            pdfTitle: 'Extrato em PDF do banco',
            pdfSubtitle: 'Lemos os lançamentos do PDF',
            sheetTitle: 'Planilha CSV ou Excel',
            sheetSubtitle: 'Modelo do Kontto ou de outros apps',
            printsTitle: 'Prints do extrato (fotos)',
            printsSubtitle: 'Último recurso, o OCR pode errar',
        },
        restore: {
            title: 'Restaurar um backup do Kontto',
            subtitle: 'Restaurar SUBSTITUI tudo; importar soma.',
            label: 'Arquivo .json ou .kontto',
            button: 'Ir para pontos de restauração',
        },
        // Metade de baixo da tela: levar os dados EMBORA. Mesma grade de fidelidade
        // da metade de cima — o backup leva tudo, a planilha leva só lançamentos.
        export: {
            section: 'Exportar',
            busy: 'Preparando o arquivo...',
            backupTitle: 'Backup completo',
            backupSubtitle: 'Leva tudo; só volta no Kontto',
            sheetTitle: 'Transações em planilha',
            sheetSubtitle: 'Planilha CSV ou relatório em PDF',
        },
        backupFileDialog: {
            title: 'Isso é um backup do Kontto',
            message: 'Backup não entra pela importação — ele substitui os dados do app. Quer ir para a tela de restauração?',
            confirm: 'Restaurar backup',
        },
        busy: {
            preparingPreview: 'Preparando a prévia...',
            readingFile: 'Lendo o arquivo...',
            readingStatement: 'Lendo o extrato...',
            readingPrints: 'Lendo os prints...',
            importing_one: 'Importando {{count}} lançamento...',
            importing_other: 'Importando {{count}} lançamentos...',
            processing: 'Processando...',
        },
        preview: {
            title: 'Prévia da importação',
            heroLabel_one: 'lançamento a importar',
            heroLabel_other: 'lançamentos a importar',
            incomeShort: 'receitas',
            expenseShort: 'despesas',
            transferShort: 'entre contas',
            accountsRow_one: '{{count}} conta nova: {{names}}',
            accountsRow_other: '{{count}} contas novas: {{names}}',
            accountsZeroed: 'Entram zeradas · ajuste abaixo',
            accountsBalance: 'Saldo do arquivo aplicado · ajuste abaixo',
            balanceFromFile: 'Saldo veio do arquivo · igual ao banco',
            taxonomyRow: '{{categories}} categorias · {{subcategories}} subcategorias novas',
            taxonomyCategoriesOnly_one: '{{count}} categoria nova',
            taxonomyCategoriesOnly_other: '{{count}} categorias novas',
            duplicatesRow_one: '{{count}} duplicado ignorado',
            duplicatesRow_other: '{{count}} duplicados ignorados',
            duplicatesSubtitle: 'Já existem no app',
            toImportChip: '{{count}} a importar',
            summaryLabel: 'Resumo',
            toImport: 'Lançamentos a importar',
            income: 'Receitas',
            expense: 'Despesas',
            transfer: 'Transferências',
            newAccounts: 'Contas novas',
            newCategories: 'Categorias novas',
            newSubcategories: 'Subcategorias novas',
            duplicates: 'Duplicados (ignorados)',
            warnings: 'Avisos',
            errors: 'Linhas com erro',
        },
        balances: {
            title: 'Contas novas — saldo',
            subtitle: 'O arquivo traz só os lançamentos, sem o saldo de partida. Por padrão as contas entram zeradas (R$ 0,00).',
            zeroLabel: 'Zerar saldo das contas novas',
            zeroOn: 'Todas começam em R$ 0,00. Desligue para informar o saldo atual de cada conta.',
            zeroOff: 'Informe o saldo atual de cada conta (ou zere) — o app ajusta o saldo inicial pra bater.',
            balancePlaceholder: 'Saldo atual',
            zero: 'Zerar',
        },
        issues: {
            title: 'Avisos e erros',
            summaryWarnings_one: '{{count}} aviso',
            summaryWarnings_other: '{{count}} avisos',
            summaryErrors_one: '{{count}} linha com erro',
            summaryErrors_other: '{{count}} linhas com erro',
            errorNote: 'A linha com erro fica de fora',
            noErrorsNote: 'Confira antes de importar',
            expand: 'Ver detalhes',
            collapse: 'Ocultar detalhes',
            detailsLabel: 'Detalhes (primeiros 8)',
            linePrefix: 'Linha {{line}}: ',
        },
        // Avisos de qualidade da leitura do extrato (lib/bankStatement) — aparecem
        // na prévia, antes de confirmar a importação.
        statementWarnings: {
            allIncome: 'Nenhum lançamento veio como saída. Alguns bancos não marcam o sinal de despesa no PDF — confira os tipos na prévia antes de importar.',
            incomplete: 'A coluna de saldo do extrato não fechou com os lançamentos lidos. Pode faltar algum item — confira antes de importar.',
            singleAccount: 'A planilha não diz de qual conta é cada lançamento — tudo vai para a conta escolhida. O saldo total fecha; a separação por conta se perde.',
            unknownYear: 'Não conseguimos confirmar o ano dos lançamentos pela planilha. Confira as datas na prévia antes de importar.',
            noDescription: 'Este relatório do Mercado Pago não diz quem você pagou nem quem te pagou: os lançamentos entram com nomes pelo tipo (Pix, pagamento com QR…) e os rendimentos somados por mês. Para ter os nomes, importe o extrato da conta em PDF.',
        },
        actions: {
            importCount: 'Importar {{count}}',
            importing: 'Importando...',
            cancel: 'Cancelar',
        },
        done: {
            title: 'Importação concluída',
            subtitle: 'Tudo entrou somando ao que você já tinha.',
            viewTransactions: 'Ver lançamentos importados',
            importAnotherShort: 'Importar outro',
            accountsCreatedNamed: 'Conta criada: {{names}}',
            accountsCreatedNamed_other: 'Contas criadas: {{names}}',
            subcategoriesSuffix_one: '+ {{count}} subcategoria',
            subcategoriesSuffix_other: '+ {{count}} subcategorias',
            leftOut: '{{duplicates}} duplicados e {{errors}} linhas com erro ficaram de fora.',
            resultLabel: 'Resultado',
            imported: 'Lançamentos importados',
            accountsCreated: 'Contas criadas',
            categoriesCreated: 'Categorias criadas',
            subcategoriesCreated: 'Subcategorias criadas',
            importAnother: 'Importar outro arquivo',
            backHome: 'Voltar ao início',
        },
        accountModal: {
            title: 'De qual conta é este extrato?',
            fileMeta_one: '{{count}} lançamento · {{period}}',
            fileMeta_other: '{{count}} lançamentos · {{period}}',
            detected: 'Nome detectado no arquivo, confirme ou troque',
            yourAccounts: 'Suas contas',
            description: 'Se já existir uma conta com esse nome, os lançamentos entram nela; senão, criamos uma nova.',
            placeholder: 'Ex.: Nubank',
            continue: 'Continuar',
        },
        help: {
            title: 'Como funciona a importação',
            body: 'A importação soma ao que você já tem — não apaga nada, diferente de restaurar um backup. Tudo acontece no seu aparelho.\n\nTem dois caminhos: o CSV no modelo do Kontto (baixe o exemplo abaixo e ajuste o seu) ou o extrato OFX que você exporta direto do banco. Você confere uma prévia antes de confirmar.',
            modelButton: 'Ver modelo e baixar exemplo',
            formats: 'Melhor → pior precisão: <0>OFX</0> e <1>PDF</1> do banco são os mais fiéis (baixe direto no app/site do banco). O CSV funciona no modelo do Kontto ou de outros apps. <2>Prints</2> são o último recurso — o OCR erra nomes e valores; use só se não conseguir o OFX/PDF. Você confere uma prévia antes de confirmar.',
        },
        toasts: {
            unrecognizedFileTitle: 'Não reconhecemos o arquivo',
            legacyXlsTitle: 'Planilha em formato antigo',
            legacyXlsBody: 'Este é um .xls antigo, que não conseguimos abrir. Abra no Excel ou Google Planilhas e salve como .xlsx ou CSV.',
            unrecognizedSheetTitle: 'Não reconhecemos esta planilha',
            unrecognizedSheetBody: 'Abrimos a planilha, mas não achamos data e valor nela. Se ela tiver uma tabela, deixe o cabeçalho (Data, Valor, Descrição…) na primeira linha; ou exporte em CSV.',
            unrecognizedFileBody: 'Faltam as colunas de Data e Valor. Veja o modelo de CSV e baixe o exemplo no link da tela.',
            nothingToImport: 'Nada para importar',
            previewFailed: 'Falha ao montar a prévia',
            readFileFailed: 'Falha ao ler o arquivo',
            notOfx: 'Arquivo não é um OFX',
            ofxEmpty: 'OFX sem lançamentos',
            readStatementFailed: 'Falha ao ler o extrato',
            unrecognizedStatementTitle: 'Não reconhecemos o extrato',
            unrecognizedPdfBody: 'Não encontramos lançamentos neste PDF. Se for fatura de cartão, use a tela do cartão; para conta, tente o OFX.',
            unrecognizedPrintsBody: 'Não achamos lançamentos nesses prints. Sempre que der, prefira o PDF/OFX do banco — o print é menos preciso.',
            pdfPasswordProtected: 'PDF protegido por senha',
            readPrintsFailed: 'Falha ao ler os prints',
            importDoneTitle: 'Importação concluída',
            importDoneBody: '{{transactions}} lançamentos, {{accounts}} contas e {{categories}} categorias.',
            importFailed: 'Falha ao importar',
        },
    },
    // app/settings/auto-categorization.tsx — Categorização automática
    autoCategorization: {
        empty: {
            title: 'Nenhuma regra',
            subtitle: 'Crie regras para categorizar transações automaticamente.',
            action: 'Criar regra',
        },
        tester: {
            typeLabel: 'Tipo',
            typeExpense: 'Despesa',
            typeIncome: 'Receita',
            testLabel: 'Teste',
            testPlaceholder: 'Digite uma descrição...',
            hint: 'Ignora acentos e pontuação. Use `*` como coringa e `|` para alternativas.',
            rulePrefix: 'Regra: {{pattern}}',
            noMatch: 'Nenhuma regra encontrou correspondência',
        },
        history: {
            title: 'Histórico antigo',
            scopeLabel: 'Escopo',
            scopeAll: 'Tudo',
            scopeExpense: 'Despesa',
            scopeIncome: 'Receita',
            showPreview: 'Ver prévia do histórico',
            previewNote: 'Calculada só quando você pede — varre seus lançamentos antigos, então fica fora do carregamento da tela.',
            calculating: 'Calculando prévia do histórico...',
            tileMatched: 'Com match',
            tileFillable: 'Preenche',
            tileOverwrite: 'Mudariam',
            noChanges: 'Nenhuma transação antiga precisa mudar com as regras atuais.',
            refresh: 'Atualizar prévia',
            applyFillable: 'Aplicar sem categoria',
            overwrite: 'Sobrescrever divergências',
            noCategory: 'Sem categoria',
        },
        rulesCount: 'Regras ({{count}})',
        ruleType: {
            income: 'Receita',
            expense: 'Despesa',
        },
        deleteDialog: {
            title: 'Excluir regra',
            message: 'Tem certeza que deseja excluir esta regra? Essa ação não pode ser desfeita.',
            confirm: 'Excluir',
        },
        reapplyDialog: {
            overwriteTitle: 'Sobrescrever histórico',
            safeTitle: 'Aplicar em histórico antigo',
            overwriteMessage: 'Isso atualiza {{count}} transações antigas que hoje já têm categoria diferente da regra sugerida.',
            safeMessage: 'Isso preenche {{count}} transações antigas sem categoria ou sem subcategoria completa.',
            overwriteConfirm: 'Sobrescrever',
            safeConfirm: 'Aplicar',
        },
    },
    // app/settings/reminders.tsx — Lembretes
    reminders: {
        // Cartão de estado da permissão no topo — o estado vem do SISTEMA, não de preferência
        // salva (hooks/useNotificationPermission.ts).
        permissionCard: {
            activeTitle: 'Notificações ativas',
            activeSubtitle: 'Os avisos chegam normalmente neste aparelho.',
            attentionTitle: 'Falta liberar as notificações',
            attentionSubtitle: 'Sem a permissão do sistema, nenhum lembrete aparece no aparelho. Suas escolhas aqui ficam guardadas.',
            attentionAction: 'Ativar notificações',
            blockedTitle: 'Nenhum lembrete vai chegar',
            blockedBadge: 'BLOQUEADO',
            blockedSubtitle: 'As notificações do Kontto estão desligadas no sistema. Suas escolhas ficam guardadas e voltam a valer quando você liberar.',
            blockedAction: 'Abrir ajustes do sistema',
            recoveryPathAndroid: 'Android › Apps › Kontto › Notificações',
            recoveryPathIos: 'Ajustes › Kontto › Notificações',
            pausedBadge: 'PAUSADO',
        },
        groups: {
            due: 'Vencimentos',
            comeback: 'Retorno',
            backup: 'Segurança dos dados',
        },
        backupAlert: {
            title: 'Avisar se ficar sem backup',
            subtitle: 'Um aviso quando seus lançamentos passarem muito tempo sem nenhuma cópia.',
        },
        due: {
            title: 'Avisos do dia',
            subtitle: 'Um resumo do que vence hoje — contas, faturas e recorrências.',
            subtitlePaused: 'Suas escolhas ficam guardadas e voltam a valer quando você liberar.',
        },
        // Rótulo curto da linha; `slots` fica como rótulo de acessibilidade (a linha sozinha,
        // fora do grupo, não diria do que é a "Manhã").
        slotsShort: {
            morning: 'Manhã',
            evening: 'Noite',
        },
        slots: {
            morning: 'Lembrete da manhã',
            evening: 'Lembrete da noite',
        },
        time: 'Horário',
        inactivity: {
            title: 'Chamar de volta',
            subtitle: 'Se você passar dias sem abrir o Kontto.',
            notifyAfter: 'Avisar depois de',
            daysOption: '{{count}} dias',
        },
        restoreDefault: 'Restaurar padrão',
    },
    // app/settings/feedback.tsx — Enviar feedback
    feedback: {
        heroTitle: 'Sua opinião constrói o Kontto',
        heroSubtitle: 'Sugestões, dúvidas ou algo que não funcionou — o app é feito por uma pessoa só, e cada mensagem é lida e respondida.',
        emailLabel: 'E-mail de contato',
        copy: 'COPIAR',
        writeEmail: 'Escrever e-mail',
        opening: 'Abrindo...',
        versionNote: 'A versão do app já vai no e-mail. Se puder, conte também o aparelho — ajuda a investigar.',
        emailSubject: 'Feedback do Kontto',
        supportIdLabel: 'Código de suporte (toque para copiar)',
        supportIdLine: 'Código de suporte: {{id}}',
        toasts: {
            copied: 'E-mail copiado',
            copyFailed: 'Não foi possível copiar',
            noMailApp: 'Nenhum app de e-mail',
            supportIdCopied: 'Código de suporte copiado',
        },
    },
};
